module.exports = __webpack_public_path__ + "static/no-smooking-f22a39e3d2094ccbf2981401d2d63d73.png";